<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <div
      class="doc-paper preview keirekisho"
      :id="idPrefix + 'preview-page-01'"
    >
      <div class="keirekisho-wapper">
        <div class="keirekisho-header">
          <div
            class="date data text-right"
            :data-highlight="highlightMessage"
            @click="goCardTo('create-date')"
            :class="highLightClass('create-date')"
          >
            <span v-html="formatedCreateDate"></span>
          </div>
          <br />
          <div
            class="data text-left"
            :data-highlight="highlightMessage"
            @click="goCardTo('company')"
            :class="highLightClass('company')"
          >
            <span
              class="name"
              :style="formatData.selFontStyle"
              v-if="formatData.company_name"
              >{{ formatData.company_name }}</span
            >
            <span
              class="name"
              :style="formatData.selFontStyle"
              v-if="formatData.staff_name"
              >{{ formatData.staff_name }}様</span
            >
          </div>
          <div
            class="data text-right"
            :data-highlight="highlightMessage"
            @click="goCardTo('letterprofile')"
            :class="highLightClass('letterprofile')"
          >
            <div class="postal-code" :style="formatData.selFontStyle">
              &#12306;{{ formLib.separatedPostNumber(basicData.postNumber) }}
            </div>
            <pre :style="formatData.selFontStyle"
              >{{ basicData.address1 }}
{{ basicData.address2 }}</pre>
            <span class="name" :style="formatData.selFontStyle"
              >{{ basicData.tel1 }}-{{ basicData.tel2 }}-{{
                basicData.tel3
              }}</span
            >
            <span
              class="name"
              :style="formatData.selFontStyle"
              v-if="basicData.email"
              >{{ basicData.email }}</span
            >
            <span class="name" :style="formatData.selFontStyle"
              >{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</span
            >
          </div>
        </div>
        <br />
        <div class="data text-center">
          <span class="name">応募書類の送付につきまして</span>
        </div>
        <br />
        <div class="keirekisho-content">
          <div
            class="input"
            :data-highlight="highlightMessage"
            @click="goCardTo('intro')"
            :class="highLightClass('intro')"
          >
            <pre
              ref="introSummary"
              :class="classObject.introSummary"
              :style="formatData.selFontStyle"
              >{{ formatData.introSummary }}</pre>
          </div>
          <br />
          <div
            class="input"
            id="pr-message"
            :data-highlight="highlightMessage"
            @click="goCardTo('entry-detail')"
            :class="highLightClass('entry-detail')"
          >
            <pre
              ref="entrySummary"
              :class="classObject.entrySummary"
              :style="formatData.selFontStyle"
              >{{ formatData.entrySummary }}</pre>
          </div>
          <br />
          <div class="data text-right">
            <span class="name">敬具</span>
          </div>
          <br />
          <br />
          <br />
          <div class="data text-center" v-if="formatData.resumeSummary">
            <span class="name">記</span>
          </div>
          <div
            class="input text-left"
            v-if="formatData.resumeSummary"
            :data-highlight="highlightMessage"
            @click="goCardTo('resume-list')"
            :class="highLightClass('resume-list')"
          >
            <pre
              ref="resumeSummary"
              :class="classObject.resumeSummary"
              :style="formatData.selFontStyle"
              >{{ formatData.resumeSummary }}</pre>
          </div>
          <div class="data text-right" v-if="formatData.resumeSummary">
            <span class="name">以上</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useFormatPreview } from '@/composables/format-edit/useFormatPreview'
import { usePreviewOverflow } from '@/composables/format-edit/usePreviewOverflow'
import { formatPreviewCreateDate } from '@/utils/format-edit/previewDates'
import { useHostServices } from '@/composables/format-edit/useHostServices'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const { formLib } = useHostServices()
const { scaleStyle, highlightMessage, goCardTo, highLightClass } =
  useFormatPreview(props)

const introSummary = ref<HTMLElement | null>(null)
const resumeSummary = ref<HTMLElement | null>(null)
const entrySummary = ref<HTMLElement | null>(null)
const overflowEls: Record<string, typeof introSummary> = {
  introSummary,
  resumeSummary,
  entrySummary
}

const { classObject, errorMessages, adjustFontSize } = usePreviewOverflow({
  getEl: (name) => overflowEls[name]?.value ?? undefined,
  maxHeights: {
    introSummary: 90,
    resumeSummary: 90,
    entrySummary: 210
  },
  watchSources: [
    { name: 'introSummary', source: () => props.formatData?.introSummary },
    { name: 'resumeSummary', source: () => props.formatData?.resumeSummary },
    { name: 'entrySummary', source: () => props.formatData?.entrySummary }
  ]
})

const formatedCreateDate = computed(() =>
  formatPreviewCreateDate(
    props.formatData?.createDate,
    formLib.dateFormat,
    'placeholder'
  )
)

function checkValid() {
  adjustFontSize('introSummary')
  adjustFontSize('resumeSummary')
  adjustFontSize('entrySummary')
}

defineExpose({ checkValid, errorMessages })
</script>
